import { IconButtonProps } from '@mui/material';
// CONSTANTS
import { TP_COLORS } from '../../constants';

export const whiteButtonStyles: IconButtonProps['sx'] = {
  backgroundColor: TP_COLORS.white,
  color: TP_COLORS.black,
  '&:default': {
    backgroundColor: TP_COLORS.white,
    color: TP_COLORS.black,
  },
  '&:focus': {
    backgroundColor: TP_COLORS.white,
    color: TP_COLORS.black,
  },
  '&:hover': {
    backgroundColor: TP_COLORS.white,
    color: TP_COLORS.black,
  },
};

export const test = '';
